import { trackBusinessRegistrationInitiated, TrackBusinessRegistrationInitiatedOptions } from '@oneflare/web-analytics';
import { memo } from 'react';

import { AnalyticsPage } from 'lib/analytics/constants';
import { OneflareAnalytics } from 'lib/analytics/oneflareAnalytics';
import { getSiteUrl } from 'lib/utils/Environment';
import CTASection from 'shared/components/CTASection/CTASection';

import { H2Styled, CTAButtonLinkStyled } from './styled/RegisterBusinessCTASection';

const SITE_URL = getSiteUrl();

const DEFAULT_REGISTER_URL = `${SITE_URL}/businesses/new`;

type RegisterBusinessCTASectionProps = {
  label?: string;
  registerUrl?: string;
  registrationBusinessInitiatedPageName?: string;
};

const RegisterBusinessCTASection = ({ registerUrl = DEFAULT_REGISTER_URL, label =  'Register business', registrationBusinessInitiatedPageName = AnalyticsPage.BusinessCentre }: RegisterBusinessCTASectionProps) => {

  const trackBusinessRegistrationInitiatedEvent = () => {
    const tracker = new OneflareAnalytics();
    trackBusinessRegistrationInitiated(tracker, 'client:RegisterBusinessCTASection:onClick', { 
      initiatedPage: registrationBusinessInitiatedPageName,
      initiatedSection: 'Final Banner',
      initiatedCtaText: label
     } as TrackBusinessRegistrationInitiatedOptions);
  };
  
  return (
    <CTASection>
      <H2Styled>Register your business to start receiving leads</H2Styled>
      <CTAButtonLinkStyled
        link={registerUrl}
        target="_blank"
        kind="outline-light-lg"
        onClick={trackBusinessRegistrationInitiatedEvent}
      >
        {label}
      </CTAButtonLinkStyled>
    </CTASection>
  );
};

export default memo(RegisterBusinessCTASection);
